<script>
import Service from '../../services/vessel-protocol';
import config from '../../common/genericPanelConf';

import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';

import Button from 'primevue/button';
import Chips from 'primevue/chips';

import GenericCustomAutocompleteV2 from '../../components/generic/GenericCustomAutocompleteV2.vue';
import GenericDateMaskV2 from '../../components/generic/GenericDateMaskV2.vue';

import { required, maxLength, minValue  } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import GenericBooleanDropdown from '../../components/generic/GenericBooleanDropdown.vue';

export default{
  setup: () => ({ v$: useVuelidate() }),

  components: {
    Button,
    //GenericDateMaskV2,
    GenericCustomAutocompleteV2,
    GenericBooleanDropdown
},
  data(){
    return {
      data: {},
      reports: [],
      categories: [],
      selectedCategory: null,
      selectedReport: null,
      filteredReports: [],
      newReport: {},
      newReportSubmitted: false,
      selectedReportFields: [],
    }
  },
  validations(){
    return {
      newReport: {},
    }
  },
  computed: {
    constants(){
        return CommonConstants;
    },
    utils(){
      return Utils;
    },
    uiPermissions(){
      return this.$store.getters['security/uiPermissions'];
    },
  },
  created(){
    this.reports = config.getConfiguration('VesselProtocolPaymentReport').reports;
    this.categories = [...new Set(this.reports.map(({category}) => category))].map((category) => ({label: category, value: category}));
  },
  mounted(){
    this.$store.dispatch('security/setNavbarTitle', 'vesselProtocol.page_title');
  },
  watch: {

  },
  methods: {
    onCategorySelected(){
      this.selectedReport = null;
      this.filteredReports = this.reports.filter((item) => item.category === this.selectedCategory);
      this.filteredReports.forEach((item) => {item.label = item.code + ' - ' + item.description})
      this.selectedReportFields = [];
    },
    onReportSelected(){
      if(this.selectedReport){
        let tempSelectedReportFields = this.reports.find((item) => item.code === this.selectedReport).fields;
        
        tempSelectedReportFields.forEach((field) => {
          if(field.type === 'field'){
            this.newReport[field.name] = {};
          } else if(field.type === 'objectArray'){
            this.newReport[field.name] = [];
            for(let i = 0; i < field.inputNumber; i++){
              this.newReport[field.name][i] = {};
              field.children.forEach((child) => {
                this.newReport[field.name][i][child.name] = null;
              })
            }
          } else {
            this.newReport[field.name] = null;
          }
          if (field.initialValue) {
            if (typeof field.initialValue === 'function'){
              this.newReport[field.name] = field.initialValue(this);
            } else {
              this.newReport[field.name] = field.initialValue;
            }
          }
        })
        this.selectedReportFields = tempSelectedReportFields;
      }
    },
    saveCallback(isPreview){
      if(isPreview){
        return ({success, data, message}) => {
          if(success){
            if (data.id2){
              Service.getPreviewVesselProtocolReport({id: data.id, id2: data.id2}, this.previewCallback())
            }else {
              Service.getPreviewVesselProtocolReport({id: data.id}, this.previewCallback())
            }
          } else{
            this.$store.dispatch("generic/setLoading", false);
            this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
          }
        }
      } else {
        return ({success, message}) => {
          this.$store.dispatch("generic/setLoading", false);
          if(success){
            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
          }else{
            this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
          }
        }
      }
    },
    previewCallback(){
      return (response) => {
        this.$store.dispatch("generic/setLoading", false);
        if(response.success){
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', 'Report-' + this.selectedReport + '.pdf');
          document.body.appendChild(fileLink);
          fileLink.click();
        }else{
          this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
        }
      }
    },
    istanceReportCallback(isPreview){
      if(isPreview){
        return ({success, data, message}) => {
          if(success){
            Service.printVesselProtocolIstanceReport(data, this.previewCallback());
          } else{
            this.$store.dispatch("generic/setLoading", false);
            this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
          }
        }
      } else {
        return ({success, message}) => {
          this.$store.dispatch("generic/setLoading", false);
          if(success){
            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
          }else{
            this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
          }
        }
      }
    },
    handleReport(isPreview){
      this.newReport.fields = [];
      this.newReport.registryDate = new Date();
      this.selectedReportFields.forEach((field) => {
        if(field.type === 'field' && this.newReport[field.name].value){
          this.newReport.fields.push(this.newReport[field.name])
        }
      })
      this.$store.dispatch("generic/setLoading", true);

  
      switch (this.selectedReport) {
        case 2:{

          let p = {
            dueDate: Utils.formatDateForAPI(this.newReport.dueDate),
            company: this.newReport.company,
            plantId: this.newReport.plantId
          }

          Service.printVesselProtocolIstanceReport(p, (response) => {
            this.$store.dispatch("generic/setLoading", false);
            if(response.success){
              var fileURL = window.URL.createObjectURL(new Blob([response.data]));
              var fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.setAttribute('download', 'Report-' + this.selectedReport + '.pdf');
              document.body.appendChild(fileLink);
              fileLink.click();
            }else{
              this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
            }
          });
          break;
        }
        case 4:
          Service.saveVesselProtocolReport4(({isPreview: isPreview, data: this.newReport}), this.saveCallback(isPreview));
          break;
        case 57:
          Service.saveVesselProtocolReport57(({isPreview: isPreview, data: this.newReport}), this.saveCallback(isPreview));
          break;
        default:
          break;
      }
    },
  handleReportExcel(isPreview){
      this.newReport.fields = [];
      this.newReport.registryDate = new Date();
      this.selectedReportFields.forEach((field) => {
        if(field.type === 'field' && this.newReport[field.name].value){
          this.newReport.fields.push(this.newReport[field.name])
        }
      })
      this.$store.dispatch("generic/setLoading", true);

  
      switch (this.selectedReport) {
        case 2:{

          let p = {
            dueDate: Utils.formatDateForAPI(this.newReport.dueDate),
            company: this.newReport.company,
            plantId: this.newReport.plantId
          }

          Service.printVesselProtocolIstanceReportExcel(p, (response) => {
            this.$store.dispatch("generic/setLoading", false);
            if(response.success){
              var fileURL = window.URL.createObjectURL(new Blob([response.data]));
              var fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.setAttribute('download', 'Report-' + this.selectedReport + '.xlsx');
              document.body.appendChild(fileLink);
              fileLink.click();
            }else{
              this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
            }
          });
          break;
        }
        case 4:
          
          Service.printVesselProtocolReport4Excel(this.newReport, (response) => {
            this.$store.dispatch("generic/setLoading", false);
            if(response.success){
              var fileURL = window.URL.createObjectURL(new Blob([response.data]));
              var fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.setAttribute('download', 'Report-' + this.selectedReport + '.xlsx');
              document.body.appendChild(fileLink);
              fileLink.click();
            }else{
              this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
            }
          });
          break;
        default:
          break;
      }
    },
    }
}

</script>

<template>
  <main>
    <div class="grid">
      <div class="col-12">
        <Fieldset :legend="$t('header')">
          <div class="grid">
            <div class="col-6">
              <label for="category" >{{ $t('vesselProtocol.categories') }}</label>
              <GenericCustomAutocompleteV2
                :onItemSelect="onCategorySelected"
                v-model="selectedCategory"
                name="category"
                id="category"
                :format="{ label: 'label', value: 'value' }"
                :staticOptions="categories"
                class="w-full p-inputtext-sm" />
            </div>
            <div class="col-6">
              <label for="report" >{{ $t('reports') }}</label>
              <GenericCustomAutocompleteV2
                :onItemSelect="onReportSelected"
                v-model="selectedReport"
                name="report"
                id="report"
                :disabled="!selectedCategory"
                :format="{ label: 'label', value: 'code' }"
                :staticOptions="filteredReports"
                class="w-full p-inputtext-sm" />
            </div>
          </div>
        </Fieldset>
      </div>
      <div class="col-12">
          <Fieldset :legend="$t('form')">
            <div class="grid">
              <template v-for="field in selectedReportFields" :key="field.name">
                <div :class="field.type === 'field' || field.type === 'objectArray' ? 'col-12' : 'col-12 lg:col-6'">
                  <label :class="{'p-error':v$.newReport[field.name] && v$.newReport[field.name].$invalid && newReportSubmitted}" :for="field.name" v-if="field.type !== 'field' && field.type !== 'objectArray'">{{ $t(field.label) }}</label>
                  <InputText 
                    v-if="field.type === 'string'"
                    :class="{'p-invalid':v$.newReport[field.name] && v$.newReport[field.name].$invalid && newReportSubmitted}"
                    :id="field.name"
                    type="text"
                    v-model="newReport[field.name]"
                    class="w-full p-inputtext-sm mt-1" />
                  <Calendar
                    v-if="field.type === 'date'"
                    :class="{'p-invalid':v$.newReport[field.name] && v$.newReport[field.name].$invalid && newReportSubmitted}"
                    placeholder="__/__/____"
                    :id="field.name"
                    v-model="newReport[field.name]"
                    class="w-full mt-1"
                    name="paymentDate" dateFormat="dd/mm/yy" :showTime="false"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                  <InputNumber
                    v-if="field.type === 'number'"
                    :class="{'p-invalid':v$.newReport[field.name] && v$.newReport[field.name].$invalid && newReportSubmitted}"
                    :id="field.name"
                    v-model="newReport[field.name]"
                    class="w-full p-inputtext-sm mt-1" />
                  <GenericCustomAutocompleteV2
                    v-if="field.type === 'select'"
                    v-model="newReport[field.name]"
                    :id="field.name"
                    :format="field.format"
                    :api="field.selectApi"
                    :queryField="field.queryField"
                    class="w-full p-inputtext-sm" />
                  <Chips
                    v-if="field.type === 'stringArray'"
                    :class="{'p-invalid':v$.newReport[field.name] && v$.newReport[field.name].$invalid && newReportSubmitted}"
                    :id="field.name"
                    v-model="newReport[field.name]"
                    class="w-full p-fluid"
                    inputClass="mt-1" />
                  <GenericBooleanDropdown 
                    v-if="field.type === 'boolean'"
                    v-model="newReport[field.name]"
                    :id="field.name"
                    class="w-full" />
                  <template v-if="field.type === 'field'">
                    <Fieldset :legend="$t(field.label)">
                      <div class="grid">
                        <div class="col-12 lg:col-4">
                          <label>{{ $t('value') }}</label>
                          <InputNumber
                            :class="{'p-invalid':v$.newReport[field.name] && v$.newReport[field.name].$invalid && newReportSubmitted}"
                            v-model="newReport[field.name]['value']"
                            class="w-full p-inputtext-sm mt-1" />
                        </div>
                        <div class="col-12 lg:col-4">
                          <label>{{ $t('vesselProtocol.dateFrom') }}</label>
                          <GenericDateMaskV2 
                            :class="{'p-invalid':v$.newReport[field.name] && v$.newReport[field.name].$invalid && newReportSubmitted}"
                            v-model="newReport[field.name]['dateFrom']"
                            class="w-full mt-1" />
                        </div>
                        <div class="col-12 lg:col-4">
                          <label>{{ $t('vesselProtocol.dateTo') }}</label>
                          <GenericDateMaskV2 
                            :class="{'p-invalid':v$.newReport[field.name] && v$.newReport[field.name].$invalid && newReportSubmitted}"
                            v-model="newReport[field.name]['dateTo']"
                            class="w-full mt-1" />
                        </div>
                      </div>
                    </Fieldset>
                  </template>
                  <template v-if="field.type === 'objectArray'">
                    <Fieldset :legend="$t(field.label)" :collapsed="field.collapsible" :toggleable="field.collapsible">
                      <div class="grid">
                        <template v-for="_, index in field.inputNumber" :key="index">
                          <template v-for="child in field.children" :key="child.name">
                            <div class="col-12 lg:col-4">
                              <label>{{ $t(child.label) }}</label>
                              <InputText 
                                v-if="child.type === 'string'"
                                type="text"
                                v-model="newReport[field.name][index][child.name]"
                                class="w-full p-inputtext-sm mt-1" />
                              <InputNumber
                                v-if="child.type === 'number'"
                                v-model="newReport[field.name][index][child.name]"
                                class="w-full p-inputtext-sm mt-1" />
                              <GenericDateMaskV2 
                                v-if="child.type === 'date'"
                                v-model="newReport[field.name][index][child.name]"
                                class="w-full mt-1" />
                            </div>
                          </template>
                        </template>
                      </div>
                    </Fieldset>
                  </template>
                  <div v-if="(v$.newReport[field.name] && v$.newReport[field.name].$invalid && newReportSubmitted) || v$.newReport[field.name] && v$.newReport[field.name].$pending.$response">
                    <small class="p-error" v-for="error in v$.newReport[field.name] && v$.newReport[field.name].$silentErrors" :key="error.$validator" >
                        {{error.$message}}
                    </small>
                  </div>
                </div>
              </template>
              <div class="col-12">
                <Button :label="$t('btn.preview')" icon="pi pi-file-pdf" class="p-button-danger mr-2" :disabled="selectedCategory === 'Certificati'" @click="handleReport(true)" v-if="selectedReport" />
                <Button :label="$t('btn.preview')" icon="pi pi-file-excel" class="p-button-success mr-2" :disabled="selectedCategory === 'Certificati'" @click="handleReportExcel(true)" v-if="selectedReport == 2 || selectedReport == 4" />
                <!-- <Button :label="$t('btn.save')" icon="pi pi-save" class="p-button-success" @click="handleReport(false)" :disabled="!uiPermissions('generalReportVesselProtocolSaveButton').isEnabled" v-if="!uiPermissions('reportVesselProtocolSaveButton').isHidden && selectedReport"/> -->
              </div>
            </div>
          </Fieldset>
      </div>
    </div>
  </main>
</template>
